:host {
	display: block;
}
:host smoothly-display {
	display: inline;
}
